module.exports = __webpack_public_path__ + "img/dxkj.40059034.png";